"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var commonTypes_1 = require("../../types/commonTypes");
var schemaTypes_1 = require("../../types/schemaTypes");
var Image_1 = __importDefault(require("@mui/icons-material/Image"));
var VideoCameraFront_1 = __importDefault(require("@mui/icons-material/VideoCameraFront"));
var Article_1 = __importDefault(require("@mui/icons-material/Article"));
var Subject_1 = __importDefault(require("@mui/icons-material/Subject"));
var styles_1 = require("@mui/styles");
var BmpIcon_1 = __importDefault(require("../FileIcons/BmpIcon"));
var GifIcon_1 = __importDefault(require("../FileIcons/GifIcon"));
var IcoIcon_1 = __importDefault(require("../FileIcons/IcoIcon"));
var PngIcon_1 = __importDefault(require("../FileIcons/PngIcon"));
var SvgIcon_1 = __importDefault(require("../FileIcons/SvgIcon"));
var TiffIcon_1 = __importDefault(require("../FileIcons/TiffIcon"));
var TifIcon_1 = __importDefault(require("../FileIcons/TifIcon"));
var Mp4Icon_1 = __importDefault(require("../FileIcons/Mp4Icon"));
var MpegIcon_1 = __importDefault(require("../FileIcons/MpegIcon"));
var TsIcon_1 = __importDefault(require("../FileIcons/TsIcon"));
var WebmIcon_1 = __importDefault(require("../FileIcons/WebmIcon"));
var Icon3gp_1 = __importDefault(require("../FileIcons/Icon3gp"));
var Icon3g2_1 = __importDefault(require("../FileIcons/Icon3g2"));
var DocIcon_1 = __importDefault(require("../FileIcons/DocIcon"));
var DocxIcon_1 = __importDefault(require("../FileIcons/DocxIcon"));
var OdpIcon_1 = __importDefault(require("../FileIcons/OdpIcon"));
var OdsIcon_1 = __importDefault(require("../FileIcons/OdsIcon"));
var OdtIcon_1 = __importDefault(require("../FileIcons/OdtIcon"));
var PdfIcon_1 = __importDefault(require("../FileIcons/PdfIcon"));
var PptIcon_1 = __importDefault(require("../FileIcons/PptIcon"));
var PptxIcon_1 = __importDefault(require("../FileIcons/PptxIcon"));
var RtfIcon_1 = __importDefault(require("../FileIcons/RtfIcon"));
var XlsIcon_1 = __importDefault(require("../FileIcons/XlsIcon"));
var XlsxIcon_1 = __importDefault(require("../FileIcons/XlsxIcon"));
var CsvIcon_1 = __importDefault(require("../FileIcons/CsvIcon"));
var HtmIcon_1 = __importDefault(require("../FileIcons/HtmIcon"));
var HtmlIcon_1 = __importDefault(require("../FileIcons/HtmlIcon"));
var JsonIcon_1 = __importDefault(require("../FileIcons/JsonIcon"));
var TxtIcon_1 = __importDefault(require("../FileIcons/TxtIcon"));
var XhtmlIcon_1 = __importDefault(require("../FileIcons/XhtmlIcon"));
var XmlIcon_1 = __importDefault(require("../FileIcons/XmlIcon"));
var WebpIcon_1 = __importDefault(require("../FileIcons/WebpIcon"));
var JpegIcon_1 = __importDefault(require("../FileIcons/JpegIcon"));
var JpgIcon_1 = __importDefault(require("../FileIcons/JpgIcon"));
var AviIcon_1 = __importDefault(require("../FileIcons/AviIcon"));
var OgvIcon_1 = __importDefault(require("../FileIcons/OgvIcon"));
var FileIconComponent = function (props) {
    var useStyles = styles_1.makeStyles(function (theme) { return ({
        icon: {
            width: props.width,
        },
    }); });
    var classes = useStyles();
    var type = props.fileSubType ? props.fileSubType : props.fileMainType;
    var getIcon = function () {
        switch (type) {
            default:
                return react_1.default.createElement(Article_1.default, { className: classes.icon });
            case schemaTypes_1.ColumnSubType.Image:
                return react_1.default.createElement(Image_1.default, { className: classes.icon });
            case schemaTypes_1.ColumnSubType.Video:
                return react_1.default.createElement(VideoCameraFront_1.default, { className: classes.icon });
            case schemaTypes_1.ColumnSubType.Text:
                return react_1.default.createElement(Subject_1.default, { className: classes.icon });
            // ImageTypes
            case commonTypes_1.ImageType.bmp:
                return react_1.default.createElement(BmpIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.gif:
                return react_1.default.createElement(GifIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.ico:
                return react_1.default.createElement(IcoIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.jpeg:
                return react_1.default.createElement(JpegIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.jpg:
                return react_1.default.createElement(JpgIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.png:
                return react_1.default.createElement(PngIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.svg:
                return react_1.default.createElement(SvgIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.tiff:
                return react_1.default.createElement(TiffIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.tif:
                return react_1.default.createElement(TifIcon_1.default, { width: props.width });
            case commonTypes_1.ImageType.webp:
                return react_1.default.createElement(WebpIcon_1.default, { width: props.width });
            // VideoTypes
            case commonTypes_1.VideoType.avi:
                return react_1.default.createElement(AviIcon_1.default, { width: props.width });
            case commonTypes_1.VideoType.mp4:
                return react_1.default.createElement(Mp4Icon_1.default, { width: props.width });
            case commonTypes_1.VideoType.mpeg:
                return react_1.default.createElement(MpegIcon_1.default, { width: props.width });
            case commonTypes_1.VideoType.ogv:
                return react_1.default.createElement(OgvIcon_1.default, { width: props.width });
            case commonTypes_1.VideoType.ts:
                return react_1.default.createElement(TsIcon_1.default, { width: props.width });
            case commonTypes_1.VideoType.webm:
                return react_1.default.createElement(WebmIcon_1.default, { width: props.width });
            case commonTypes_1.VideoType['3gp']:
                return react_1.default.createElement(Icon3gp_1.default, { width: props.width });
            case commonTypes_1.VideoType['3g2']:
                return react_1.default.createElement(Icon3g2_1.default, { width: props.width });
            // DocumentTypes
            case commonTypes_1.DocumentType.doc:
                return react_1.default.createElement(DocIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.docx:
                return react_1.default.createElement(DocxIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.odp:
                return react_1.default.createElement(OdpIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.ods:
                return react_1.default.createElement(OdsIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.odt:
                return react_1.default.createElement(OdtIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.pdf:
                return react_1.default.createElement(PdfIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.ppt:
                return react_1.default.createElement(PptIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.pptx:
                return react_1.default.createElement(PptxIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.rtf:
                return react_1.default.createElement(RtfIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.xls:
                return react_1.default.createElement(XlsIcon_1.default, { width: props.width });
            case commonTypes_1.DocumentType.xlsx:
                return react_1.default.createElement(XlsxIcon_1.default, { width: props.width });
            // TextTypes
            case commonTypes_1.TextType.csv:
                return react_1.default.createElement(CsvIcon_1.default, { width: props.width });
            case commonTypes_1.TextType.htm:
                return react_1.default.createElement(HtmIcon_1.default, { width: props.width });
            case commonTypes_1.TextType.html:
                return react_1.default.createElement(HtmlIcon_1.default, { width: props.width });
            case commonTypes_1.TextType.json:
                return react_1.default.createElement(JsonIcon_1.default, { width: props.width });
            case commonTypes_1.TextType.txt:
                return react_1.default.createElement(TxtIcon_1.default, { width: props.width });
            case commonTypes_1.TextType.xhtml:
                return react_1.default.createElement(XhtmlIcon_1.default, { width: props.width });
            case commonTypes_1.TextType.xml:
                return react_1.default.createElement(XmlIcon_1.default, { width: props.width });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, getIcon()));
};
exports.default = FileIconComponent;
